import { Preferences } from '@capacitor/preferences'
import { platform } from '@utils/capacitor-helper'

const REFERRAL_STORAGE_KEY = 'referral_id'

/**
 * Save referral ID to storage (localStorage for web, Capacitor Preferences for native)
 */
export async function saveReferralId(referralId: string): Promise<void> {
    if (platform === 'web') {
        localStorage.setItem(REFERRAL_STORAGE_KEY, referralId)
    } else {
        await Preferences.set({ key: REFERRAL_STORAGE_KEY, value: referralId })
    }
}

/**
 * Get referral ID from storage
 */
export async function getReferralId(): Promise<string | null> {
    if (platform === 'web') {
        return localStorage.getItem(REFERRAL_STORAGE_KEY)
    } else {
        const result = await Preferences.get({ key: REFERRAL_STORAGE_KEY })
        return result.value
    }
}

/**
 * Clear referral ID from storage
 */
export async function clearReferralId(): Promise<void> {
    if (platform === 'web') {
        localStorage.removeItem(REFERRAL_STORAGE_KEY)
    } else {
        await Preferences.remove({ key: REFERRAL_STORAGE_KEY })
    }
}
